import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   meta: {
  //     layout: "WebLayout",
  //   },
  //   component: () => import('../views/Pages/Home2View.vue')
  // },
  {
    path: '/',
    name: 'Home',
    meta: {
      layout: "WebLayout",
    },
    component: () => import('../views/Pages/Home3View.vue')
  },
  {
    path: '/home2',
    name: 'Home2',
    meta: {
      layout: "WebLayout",
    },
    component: () => import('../views/Pages/Home3View.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    meta: {
      layout: "WebLayout",
    },
    component: () => import('../views/Pages/ContactView.vue')
  },
  {
    path: '/terms-of-use',
    name: 'terms',
    meta: {
      layout: "WebLayout",
    },
    component: () => import('../views/Pages/TermsView.vue')
  },
  {
    path: '/memberships',
    name: 'Memberships',
    meta: {
      layout: "WebLayout",
    },
    component: () => import('../views/Pages/MembershipsListView.vue')
  },
  {
    path: '/services/ts8',
    name: 'TS8',
    meta: {
      layout: "WebLayout",
    },
    component: () => import('../views/Pages/Services/TS8View.vue')
  },
  {
    path: '/services/market',
    name: 'Market',
    meta: {
      layout: "WebLayout",
    },
    component: () => import('../views/Pages/Services/MarketView.vue')
  },
  {
    path: '/services/signals',
    name: 'Signals',
    meta: {
      layout: "WebLayout",
    },
    component: () => import('../views/Pages/Services/SignalsView.vue')
  },
  {
    path: '/services/academy',
    name: 'Academy',
    meta: {
      layout: "WebLayout",
    },
    component: () => import('../views/Pages/Services/AcademyView.vue')
  },
  {
    path: '/services/real-estate-fund',
    name: 'RealEstateFund',
    meta: {
      layout: "WebLayout",
    },
    component: () => import('../views/Pages/Services/RealEstateFundView.vue')
  },
  {
    path: '/services/affiliate',
    name: 'Affiliate',
    meta: {
      layout: "WebLayout",
    },
    component: () => import('../views/Pages/Services/AffiliateView.vue')
  },
  


  {
    path: '/services/ts8-chart',
    name: 'TS8Chart',
    meta: {
      layout: "WebLayout",
    },
    component: () => import('../views/Pages/Services/TS8ChartView.vue')
  },
  {
    path: '/sign-up',
    name: 'SignUp',
    meta: {
      layout: "RegLayout",
    },
    component: () => import('../views/Pages/SignUpView.vue')
  },
  {
    path: '/sign-in',
    name: 'SignIn',
    meta: {
      layout: "RegLayout",
    },
    component: () => import('../views/Pages/SignInView.vue')
  },
  {
    path: '/verify-account',
    name: 'VerifyAccount',
    meta: {
      layout: "RegLayout",
    },
    component: () => import('../views/Pages/VerifyAccountView.vue')
  },
  {
    path: '/create-password',
    name: 'ResetPassword',
    meta: {
      layout: "RegLayout",
    },
    component: () => import('../views/Pages/ResetPasswordView.vue')
  },
  
  {
    path: '/dashboard',
    name: 'Dashboard',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    
    component: () => import('../views/Dashboard/DashboardView.vue')
  },
  {
    path: '/dashboard/memberships',
    name: 'DashboardMemberships',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    
    component: () => import('../views/Dashboard/MembershipsListView.vue')
  },
  {
    path: '/dashboard/memberships/index/:id',
    name: 'DashboardMembershipsIndex',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    
    component: () => import('../views/Dashboard/MembershipsIndexView.vue')
  },
  
  {
    path: '/terms',
    name: 'Terms',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    
    component: () => import('../views/Dashboard/SubscriptionTermsView.vue')
  },
  {
    path: '/membership-payment',
    name: 'MembershipPayment',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    
    component: () => import('../views/Dashboard/MembershipPaymentView.vue')
  },
  {
    path: '/referral-payment',
    name: 'ReferralPayment',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    
    component: () => import('../views/Dashboard/ReferralPaymentView.vue')
  },
  
  {
    path: '/ranks',
    name: 'Ranks',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    
    component: () => import('../views/Dashboard/RanksView.vue')
  },
  {
    path: '/team',
    name: 'Team',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    
    component: () => import('../views/Dashboard/TeamViewLAST.vue')
  },
  {
    path: '/team-member',
    name: 'TeamMember',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    
    component: () => import('../views/Dashboard/TeamMember.vue')
  },
  {
    path: '/funds',
    name: 'Funds',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    
    component: () => import('../views/Dashboard/FundsView.vue')
  },
  {
    path: '/my-Profile',
    name: 'Profile',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    component: () => import('../views/Dashboard/ProfileView.vue')
  },
  {
    path: '/my-orders',
    name: 'MyOrders',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    component: () => import('../views/Dashboard/MyOrdersView.vue')
  },
  {
    path: '/order-details/:id',
    name: 'OrderDetails',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    component: () => import('../views/Dashboard/OrderDetailsView.vue')
  },
  {
    path: '/my-Profile',
    name: 'Profile',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    component: () => import('../views/Dashboard/ProfileView.vue')
  },
  {
    path: '/my-orders',
    name: 'MyOrders',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    component: () => import('../views/Dashboard/MyOrdersView.vue')
  },
  {
    path: '/order-details/:id',
    name: 'OrderDetails',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    component: () => import('../views/Dashboard/OrderDetailsView.vue')
  },
  {
    path: '/order-payment/:id',
    name: 'OrderPayment',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    component: () => import('../views/Dashboard/OrderPaymentView.vue')
  },
  {
    path: '/my-billings',
    name: 'MyBillings',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    component: () => import('../views/Dashboard/MyBillingsView.vue')
  },
  {
    path: '/orders-and-billings',
    name: 'OrdersAndBillings',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    component: () => import('../views/Dashboard/OrdersAndBillingsView.vue')
  },
  {
    path: '/billing-details/:id',
    name: 'BillingDetails',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    component: () => import('../views/Dashboard/BillingDetailsView.vue')
  },
  {
    path: '/packages/:id',
    name: 'PackageIndex',
    meta: {
      layout: "UserLayout",
      requiredAuth:true,
    },
    
    component: () => import('../views/Dashboard/PackagesIndexView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
   scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    return { top: 0 }
  },
})
router.beforeEach((to, from, next) => {
  if (to.meta.requiredAuth ) {
    if($cookies.isKey("_TrendsU") && $cookies.isKey("_TrendsAT") ){
      next();
    }
    else {
      next('/sign-in');
    }
  }
  
  else{ next();}

});

export default router
